import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const CCOFMD_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/ccofmd/logo.png",
        alt: "Carroll Counseling of Maryland Logo",
        style: { width: "350px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 23,
  state: "MD",
  departmentIds: [144, 147, 163, 164, 267],
};
